import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24bdc2e2&scoped=true"
import script from "./index.ts?vue&type=script&lang=js&external"
export * from "./index.ts?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=24bdc2e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bdc2e2",
  null
  
)

export default component.exports